<template>
  <div v-if="integration && (integration.active || hasSyncError)">
  <div class="integration-link-container" data-toggle="dropdown">
    <div class="integration-link-logo">
      <img :src="imagePath" />
    </div>
    <div class="integration-link-name">
      <i class="far fa-ellipsis-h fa-fw integration-icon-action" />
      {{name}}
    </div>
  </div>
  <ul class="dropdown-menu">
    <DropdownMenuItem icon="fa-wifi" disabled>Status: {{status}}</DropdownMenuItem>
    <DropdownMenuItem icon="fa-external-link" v-if="integration.link" :link="integration.link">View Item</DropdownMenuItem>
    <DropdownMenuDivider v-if="canResyncItem || canRelinkItem" />
    <DropdownMenuItem icon="fa-sync" v-if="canResyncItem" @click="onResyncItem">{{resyncLabel}}</DropdownMenuItem>
    <DropdownMenuItem icon="fa-link" v-if="canRelinkItem" @click="onRelinkItem">{{relinkLabel}}</DropdownMenuItem>
  </ul>
  </div>
</template>

<style scoped lang="scss">
$integration-logo-size: 20px;

.integration-link-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid #efefef;
  border-radius: 6px;
  cursor:pointer;
}
.integration-link-logo {
  width: calc(#{$integration-logo-size} + 8px);
  padding: 3px 4px;
}
.integration-link-logo > img {
  width: $integration-logo-size;
}
.integration-link-name {
  text-align: left;
  font-weight: bold;
  flex: 1;
  margin: auto 0;
  font-size: 11px;
  padding-left: 2px;
}
.integration-icon-action {
  visibility: hidden;
  float: right;
  margin-right: 6px;
  margin-top: 2px;
}
.integration-link-container:hover .integration-icon-action {
  visibility: visible;
}
</style>

<script>
export default {
  name: 'LinkIntegrationLink',
  props: {
    integration: Object
  },
  computed: {
    link() {
      if(!this.integration.link)
        return '#'
      return this.integration.link
    },
    name() {
      return this.integration.name
    },
    status() {
      if(this.hasSyncError)
        return this.integration.errorMessage
      if(!this.integration.linked)
        return 'Pending Sync'
      return 'Synced'
    },
    hasSyncError() {
      return this.integration.syncError
    },
    isItemLinked() {
      return this.integration.linked
    },
    canResyncItem() {
      if(!this.isItemLinked)
        return false
      if(this.integration && this.integration.options && this.integration.options.resync) {
        if(!this.integration.options.resync.enabled)
          return false

        if(!this.userHasUpdatePermission(this.integration.options.resync.permissionRequired))
          return false

        return true
      }
      return false
    },
    resyncLabel() {
      if(this.integration && this.integration.options && this.integration.options.resync) {
        return this.integration.options.resync.name
      }
      return 'Resync Item'
    },
    canRelinkItem() {
      if(!this.isItemLinked)
        return false
      if(this.integration && this.integration.options && this.integration.options.relink) {
        if(!this.integration.options.relink.enabled)
          return false

        if(!this.userHasUpdatePermission(this.integration.options.relink.permissionRequired))
          return false

        return true
      }
      return false
    },
    relinkLabel() {
      if(this.integration && this.integration.options && this.integration.options.relink) {
        return this.integration.options.relink.name
      }
      return 'Relink Item'
    },
    imagePath() {
      return `/glass/integrations/${this.integration.imagePath}`
    }
  },
  methods: {
    onResyncItem() {
      let resyncLink = this.integration.options.resync.link
      if(!resyncLink)
        return

      this.displayProcessingDialog({
        title: 'Resyncing Item',
        message: 'Resyncing',
        icon: 'fa-sync',
        onBeforeOpen: (instance) => {
          this.$api.post(resyncLink)
          .then(() => {
            instance.hide()

            this.$emit('refresh')
          })
          .catch(err => {
            instance.hide()
            this.displayNetworkError(err, 'Error Syncing Item')
          })
        }
      }, {
        mountBody: true
      })
    },
    onRelinkItem() {
      this.$emit('relink', {
        integration: this.integration
      })
    }
  }
}
</script>